var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.addBoxShow
        ? _c("addBox", {
            ref: "addBox",
            attrs: {
              "edit-data": _vm.editData,
              "daily-id": 1,
              "edit-id": _vm.editId,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("detail-examine", { ref: "detailExamine" }),
      _vm._v(" "),
      _c("apply-for-payment", {
        ref: "applyForPayment",
        attrs: { "form-data": _vm.applyData },
      }),
      _vm._v(" "),
      _c("invoice-details", {
        ref: "invoiceView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("edit-contract", {
        ref: "editContract",
        attrs: { "form-data": _vm.contractData },
      }),
      _vm._v(" "),
      _c("edit-customer", {
        ref: "editCustomer",
        attrs: { "form-data": _vm.customerData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }